function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import EmptyState from '@adsk/alloy-react-empty-state';
import { useLocale } from '@adsk/alloy-react-locale';
import { SimpleModal } from '@adsk/alloy-react-modal';
import ProgressRing from '@adsk/alloy-react-progress-ring';
import { bodyStyle, subscriptionsContainer, ErrorLabel, loadingSpinnerContainerStyles } from './helpers/styles';
import SubscriptionItem from '../SubscriptionItem/index';
const SubscriptionsModal = _ref => {
  var _T$translate;
  let {
    onClose,
    subscriptions,
    error,
    isLoading,
    onClickTryAgain
  } = _ref;
  // First item is always expanded
  const [expandedItems, setExpandedItems] = useState({
    0: true
  });
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../../i18n/".concat(locale, ".json"));
  });
  const hasSubscriptions = (subscriptions === null || subscriptions === void 0 ? void 0 : subscriptions.length) > 0;
  const LoadingSpinner = () => {
    return /*#__PURE__*/React.createElement("div", {
      "data-testid": "SubscriptionsModal__LoadingSpinner",
      style: loadingSpinnerContainerStyles
    }, /*#__PURE__*/React.createElement(ProgressRing, null));
  };
  const EmptyStateLabel = () => {
    if (error) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ErrorLabel, {
        "data-testid": "SubscriptionModal_EmptyState_Label"
      }, T.translate('FETCH_SUBSCRIPTIONS_ERROR')), /*#__PURE__*/React.createElement("a", {
        onClick: onClickTryAgain,
        style: {
          cursor: 'pointer'
        }
      }, T.translate('TRY_AGAIN')));
    }
    return /*#__PURE__*/React.createElement(ErrorLabel, {
      "data-testid": "SubscriptionModal_ErrorState_Label"
    }, T.translate('NO_SUBSCRIPTIONS_ACTIVE'));
  };
  const ModalContent = () => {
    if (isLoading) {
      return /*#__PURE__*/React.createElement(LoadingSpinner, null);
    }
    if (hasSubscriptions && !error) {
      return /*#__PURE__*/React.createElement("div", {
        style: subscriptionsContainer
      }, subscriptions.map((subscription, index) => {
        return /*#__PURE__*/React.createElement(SubscriptionItem, {
          key: "".concat(subscription.offeringName, "_").concat(index),
          subscription: subscription,
          expanded: expandedItems[index],
          onExpand: () => {
            const newExpand = _objectSpread(_objectSpread({}, expandedItems), {}, {
              [index]: !expandedItems[index]
            });
            setExpandedItems(newExpand);
          }
        });
      }));
    }
    return /*#__PURE__*/React.createElement(EmptyState, {
      "data-testid": "SubscriptionsModal__EmptyState",
      illustrationType: "buildingConstructionGrey"
    }, /*#__PURE__*/React.createElement(EmptyStateLabel, null));
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    title: (_T$translate = T.translate('MY_SUBSCRIPTIONS')) === null || _T$translate === void 0 ? void 0 : _T$translate.toString(),
    onClose: onClose,
    show: true,
    modalBodyProps: {
      style: bodyStyle
    }
  }, /*#__PURE__*/React.createElement(ModalContent, null));
};
SubscriptionsModal.displayName = 'SubscriptionsModal';
SubscriptionsModal.propTypes = {
  /** Handler for close modal event */
  onClose: PropTypes.func.isRequired,
  /**  User subscriptions and products*/
  subscriptions: PropTypes.array.isRequired,
  error: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onClickTryAgain: PropTypes.func.isRequired
};
export default SubscriptionsModal;
//# sourceMappingURL=component.js.map